import React, { useState, Suspense } from "react";
import PropTypes from "prop-types";

//hooks
import useAxios from "../../hooks/useAxios";

//comps
const PageGrid = React.lazy(() => import("../PageGrid"));
const ContentGrid = React.lazy(() => import("../ContentGrid"));
const Filters = React.lazy(() => import("../Filters"));
const VendorCard = React.lazy(() => import("./VendorCard"));
const Location = React.lazy(() => import("./Location"));
const NoResults = React.lazy(() => import("../NoResults"));
import Loading from "../Loading";

//style rules
import { Colors } from "../../styles";

const App = ({ filtersJson }) => {
	const [filters] = useState(filtersJson ? JSON.parse(filtersJson) : []);
	const [selectedFilter, setSelectedFilter] = useState({
		slug: "all",
	});

	const selectFilter = (filter) => {
		setSelectedFilter(filter);
	};

	const vendors = useAxios("shopping");

	const filterVendors = () => {
		return vendors.filter(
			(vendor) => vendor["location-slug"] === selectedFilter.slug
		);
	};

	const renderVendors = () => {
		if (vendors.length == 0) {
			return (
				<NoResults
					color={Colors.base.white}
					text={"Stay tuned for upcoming vendors"}
				/>
			);
		} else {
			if (selectedFilter.slug === "all") {
				return vendors.map((vendor) => {
					return <VendorCard vendor={vendor} key={vendor.id} />;
				});
			} else {
				const filteredVendors = filterVendors();
				if (filteredVendors.length) {
					return filteredVendors.map((vendor) => {
						return <VendorCard vendor={vendor} key={vendor.id} />;
					});
				} else {
					return (
						<NoResults
							color={Colors.base.white}
							text={"Stay tuned for upcoming vendors"}
						/>
					);
				}
			}
		}
	};

	const renderLocation = () => {
		if (selectedFilter.slug !== "all") {
			let selectedLocation = {
				name: selectedFilter.name,
				location: selectedFilter.location,
				excerpt: selectedFilter.excerpt,
			};
			if (selectedLocation) {
				return <Location location={selectedLocation} />;
			}
		}
	};
	return (
		<Suspense fallback={<Loading />}>
			<PageGrid>
				<Filters
					isRides={true}
					filters={filters}
					selectedFilter={selectedFilter}
					selectFilter={selectFilter}
				/>
				{/* displaying the location based on the filter selected */}
				{renderLocation()}
				<ContentGrid padding={"7rem 0 12rem 0"}>{renderVendors()}</ContentGrid>
			</PageGrid>
		</Suspense>
	);
};

export default App;

App.propTypes = {
	pageTitle: PropTypes.string,
	filtersJson: PropTypes.any,
	locationsJson: PropTypes.any,
};
